<template>
  <layout-private :customer="customer">
    <div class="row">

      <div v-if="$route.name=='viewPlan'" class="corner-actions-menu d-flex flex-column">
        <button class="btn btn-close btn-close-plan" @click="closePlan">
          <i class="fas fa-2x fa-times"></i>
        </button>
        <button v-if="!loading && treatment_plan && treatPlanData"  class="btn btn-icon" @click="saveUnsignedPlan">
          <i v-if="loadingUnsignedImageUpload" class="fas fa-2x fa-fw fa-pulse fa-spinner"></i>
          <span v-if="!loadingUnsignedImageUpload" class="fa-stack">
            <i class="fas fa-2x fa-stack-2x fa-save"></i>
            <i v-if="successUnsignedImageUpload" class="fas fa-stack-1x fa-check color-green"></i>
          </span>
        </button>
      </div>
      

      <div class="col-intro col-xl-8 offset-xl-2 col-lg-10 offset-lg-1 d-flex flex-column justify-content-between">

        <p v-if="pat_name" class="text-center snug sm"><em>prepared for {{ pat_name }}</em></p>
        
        <div>
          <h3 class="title"><strong><span class="hilite-salmon">why</span> did my dentist suggest this <span class="hilite-green">care</span>?</strong></h3>
        <h3 class="normal-weight">understand what's wrong without all the medical jargon. feel free to take your time reading, and ask questions. we don't want you to feel pressured.</h3>

        <h3 class="title"><strong><span class="hilite-salmon">why</span> should I <span class="hilite-green">care</span>?</strong></h3>
        <h3 class="normal-weight">this is not a sales pitch. learn how treatment can affect your life and how much it costs, so you can make decisions based on what matters to you.</h3>
        </div>

        <div class="text-center">
          <button v-if="!loading && treatment_plan && treatPlanData" class="btn btn-scroll text-center" @click="scrollToPlan">
            <h3 class="normal-weight">scroll down to start</h3>
            <img src="../assets/img/icon-angle-double-down-custom@2x.png" alt="why/care" width="41px" height="44px">
          </button>

          <p v-if="loading || !treatment_plan || !treatPlanData" class="light-weight text-center">
            <i class="far fa-fw fa-pulse fa-spinner"></i><br>
            <small>loading, please wait</small>
          </p>
          <list-errors :errors="errors"></list-errors>
        </div>
        
      </div> <!-- /.col -->

      <div v-if="treatPlanData && treatPlanData.length" class="col-12">
        <hr class="hr-dim-color">

        <div ref="tpTitle" class="tp-title text-center">
          <h3>Treatment Plan<span v-if="pat_name"> for {{ pat_name }}</span></h3>
          <h1>{{ treatment_plan.Heading }}</h1>
          <p><em>prepared {{ treatment_plan.SecDateTEdit | prettyDateShortFromDT }}</em></p>
          <p v-if="patGoal && patGoal.length" v-for="pg in patGoal" class="patient-goal text-center"><patient-goal :patGoal="pg"></patient-goal></p>
        </div>

      </div> <!-- /.col -->

      <image-gallery v-if="treatPlanData"></image-gallery>

      <div v-if="treatPlanData && treatPlanData.length && locationProcCats" class="col-12">
        
        <div v-if="procsFilteredAdv && procsFilteredAdv.length && (!hasPromoAdv || (hasPromoAdv && procsFilteredAdv.length>1))" class="row row-section row-section-adv">
          <button @click="showTxtAdv=!showTxtAdv" class="col-12 btn btn-section btn-section-adv d-flex justify-content-end align-items-center">
            <h2>Advancing Disease Care</h2>
            <p class="ml-auto"><em>(click to <span v-if="showTxtAdv">collapse</span><span v-if="!showTxtAdv">expand</span>)</em></p>
            <h3>Why should I care?</h3>
            <i v-if="showTxtAdv" class="fas fa-minus-square"></i>
            <i v-if="!showTxtAdv" class="fas fa-plus-square"></i>
          </button>
          <div v-if="showTxtAdv" class="col col-12 col-lg-4">
            <img src="../assets/img/icon-path-step-green.svg" alt="why/care" width="65px" height="50px">
            <h3>do this first.</h3>
            <h3>urgent treatment that can't wait.</h3>
          </div> <!-- /.col -->
          <div v-if="showTxtAdv"class="col col-12 col-lg-4">
            <h2>Why</h2>
            <hr class="hr-salmon">
            <ul class="icon-list icon-list-warnings">
              <li>You have oral disease that grows in size, potential discomfort, and cost to fix every day that it continues to advance.</li>
              <li>These infection and inflammation issues can contribute to heart disease, cancer, diabetes, and other serious health issues.</li>
            </ul>
          </div> <!-- /.col -->
          <div v-if="showTxtAdv" class="col col-12 col-lg-4">
            <h2>Care</h2>
            <hr class="hr-green">
            <ul class="icon-list icon-list-checks-circle">
              <li>This care will help you get the advancing disease under control.</li>
              <li>Save money, keep your teeth. Avoid losing teeth or eating ability.</li>
              <li>It's cheaper &amp; easier to fix now. Avoid increased expense and hassle to fix later.</li>
            </ul>
          </div> <!-- /.col -->
        </div> <!-- /.row -->
        <div v-if="procsFilteredAdv && procsFilteredAdv.length && (!hasPromoAdv || (hasPromoAdv && procsFilteredAdv.length>1))" class="row row-table">
          <div class="col-xl-8 col-lg-10 col-12 offset-xl-2 offset-lg-1">
            <table class="table table-app table-category">
              <thead>
                <tr>
                  <th>Priority</th>
                  <th>Procedure Description</th>
                  <th>Cost</th>
                  <th>After Benefits</th>
                </tr>
              </thead>
              <tbody v-for="prio in procsAdvPrios">
                <tr v-for="proc in procsFilteredAdv.filter(p => p.priority == prio)">
                  <td>{{ proc.priority }}</td>
                  <td>
                    <span v-if="locationProcCats[`${proc.ProcCode}`] && locationProcCats[`${proc.ProcCode}`].friendly_desc" class="desc-friendly"> {{ locationProcCats[`${proc.ProcCode}`].friendly_desc }}</span>
                    <span class="desc" v-else>{{ proc.Descript }}</span>
                    <span v-if="proc.ToothNumTP" class="tooth">, tooth: {{ proc.ToothNumTP }}</span>
                  </td>
                  <td>${{ proc.FeeAmt.toFixed(2) }}</td>
                  <td v-if="location && activeHaFeeSchedName && location[activeHaFeeSchedName] && location[activeHaFeeSchedName][proc.ProcCode]" class="ha-highlight">{{ location[activeHaFeeSchedName][proc.ProcCode].FeeAmount }}</td>
                  <td v-else>${{ proc.PatAmt.toFixed(2) }}</td>
                </tr>
                <!-- show subtotal only if there are multiple subtotals by priority or a subtotal for remaining -->
                <tr class="subtot-internal" v-if="(procsAdvPrios && procsAdvPrios.length && procsAdvPrios.length > 1) || procsFilteredAdv.filter(p => !p.priority && p.priority !== '0').length">
                  <td colspan="2" class="normal-weight">Subtotal for Priority {{ prio }}</td>
                  <td class="normal-weight">${{ calcFilteredPrioCost(prio, [...procsFilteredAdv]) }}</td>
                  <td class="normal-weight">${{ calcFilteredPrioABCost(prio, [...procsFilteredAdv], "advancing") }}</td>
                </tr>
              </tbody>
              <tbody v-if="procsFilteredAdv.filter(p => !p.priority && p.priority !== '0').length">
                <!-- procs with no priority level -->
                <tr v-for="proc in procsFilteredAdv.filter(p => !p.priority && p.priority !== '0')">
                  <td>-</td>
                  <td>
                    <span v-if="locationProcCats[`${proc.ProcCode}`] && locationProcCats[`${proc.ProcCode}`].friendly_desc" class="desc-friendly"> {{ locationProcCats[`${proc.ProcCode}`].friendly_desc }}</span>
                    <span class="desc" v-else>{{ proc.Descript }}</span>
                    <span v-if="proc.ToothNumTP" class="tooth">, tooth: {{ proc.ToothNumTP }}</span>
                  </td>
                  <td>${{ proc.FeeAmt.toFixed(2) }}</td>
                  <td v-if="location && activeHaFeeSchedName && location[activeHaFeeSchedName] && location[activeHaFeeSchedName][proc.ProcCode]" class="ha-highlight">{{ location[activeHaFeeSchedName][proc.ProcCode].FeeAmount }}</td>
                  <td v-else>${{ proc.PatAmt.toFixed(2) }}</td>
                </tr>
                <!-- show subtotal only if there are also subtotals by priority -->
                <tr class="subtot-internal" v-if="procsAdvPrios && procsAdvPrios.length">
                  <td colspan="2" class="normal-weight">Subtotal for Remaining</td>
                  <td class="normal-weight">${{ calcFilteredPrioCost(null, [...procsFilteredAdv]) }}</td>
                  <td class="normal-weight">${{ calcFilteredPrioABCost(null, [...procsFilteredAdv], "advancing") }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr v-if="procsAdvPromoTot">
                  <td></td>
                  <td>Save 10% on Advancing Disease Care today or tomorrow</td>
                  <td></td>
                  <td>-${{ procsAdvPromoTot.toFixed(2) }}</td>
                </tr>
                <tr class="subtot">
                  <td>Subtotal</td>
                  <td></td>
                  <td>${{ procsAdvCostTot.toFixed(2) }}</td>
                  <td>${{ procsAdvABTot.toFixed(2) }}</td>
                </tr>
              </tfoot>
            </table>
          </div> <!-- /.col -->
        </div> <!-- /.row -->

        
        <div v-if="procsFilteredReb && procsFilteredReb.length && (!hasPromoReb || (hasPromoReb && procsFilteredReb.length>1))" class="row row-section row-section-reb">
          <button @click="showTxtReb=!showTxtReb" class="col-12 btn btn-section btn-section-reb d-flex justify-content-end align-items-center">
            <h2>Rebuilding Care</h2>
            <p class="ml-auto"><em>(click to <span v-if="showTxtReb">collapse</span><span v-if="!showTxtReb">expand</span>)</em></p>
            <h3>Why should I care?</h3>
            <i v-if="showTxtReb" class="fas fa-minus-square"></i>
            <i v-if="!showTxtReb" class="fas fa-plus-square"></i>
          </button>
          <div v-if="showTxtReb" class="col col-12 col-lg-4">
            <img src="../assets/img/icon-path-step-blue.svg" alt="why/care" width="65px" height="50px">
            <h3>do when you can.</h3>
            <h3>prevent more problems.</h3>
          </div> <!-- /.col -->
          <div v-if="showTxtReb"class="col col-12 col-lg-4">
            <h2>Why</h2>
            <hr class="hr-salmon">
            <ul class="icon-list icon-list-warnings">
              <li>Losing tooth, gum, and bite is a domino effect, a little leads to more and more over time.</li>
              <li>If you don't rebuild, some teeth may be working harder than others, and are susceptible to breakdown and loss over the long term.</li>
              <li>Your smile may not look its best. Now that you're healthy, you have time to consider if cosmetic options are important to you.</li>
            </ul>
          </div> <!-- /.col -->
          <div v-if="showTxtReb" class="col col-12 col-lg-4">
            <h2>Care</h2>
            <hr class="hr-green">
            <ul class="icon-list icon-list-checks-circle">
              <li>Take care of your future self. As you age, ensure your teeth and mouth are stable and healthy well into your golden years with stable teeth, gum, and bite health.</li>
              <li>Feel confident. A healthy smile isn't just for others to enjoy, but can make you feel better about yourself and put some pep in your step!</li>
            </ul>
          </div> <!-- /.col -->
        </div>
        <div v-if="procsFilteredReb && procsFilteredReb.length && (!hasPromoReb || (hasPromoReb && procsFilteredReb.length>1))" class="row row-table">
          <div class="col-xl-8 col-lg-10 col-12 offset-xl-2 offset-lg-1">
            <table class="table table-app table-category">
              <thead>
                <tr>
                  <th>Priority</th>
                  <th>Procedure Description</th>
                  <th>Cost</th>
                  <th>After Benefits</th>
                </tr>
              </thead>
              <tbody v-for="prio in procsRebPrios">
                <tr v-for="proc in procsFilteredReb.filter(p => p.priority == prio)">
                  <td>{{ proc.priority }}</td>
                  <td>
                    <span v-if="locationProcCats[`${proc.ProcCode}`] && locationProcCats[`${proc.ProcCode}`].friendly_desc" class="desc-friendly"> {{ locationProcCats[`${proc.ProcCode}`].friendly_desc }}</span>
                    <span class="desc" v-else>{{ proc.Descript }}</span>
                    <span v-if="proc.ToothNumTP" class="tooth">, tooth: {{ proc.ToothNumTP }}</span>
                  </td>
                  <td>${{ proc.FeeAmt.toFixed(2) }}</td>
                  <td v-if="location && activeHaFeeSchedName && location[activeHaFeeSchedName] && location[activeHaFeeSchedName][proc.ProcCode]" class="ha-highlight">{{ location[activeHaFeeSchedName][proc.ProcCode].FeeAmount }}</td>
                  <td v-else>${{ proc.PatAmt.toFixed(2) }}</td>
                </tr>
                <!-- show subtotal only if there are multiple subtotals by priority or a subtotal for remaining -->
                <tr class="subtot-internal" v-if="(procsRebPrios && procsRebPrios.length && procsRebPrios.length > 1) || procsFilteredReb.filter(p => !p.priority && p.priority !== '0').length">
                  <td colspan="2" class="normal-weight">Subtotal for Priority {{ prio }}</td>
                  <td class="normal-weight">${{ calcFilteredPrioCost(prio, [...procsFilteredReb]) }}</td>
                  <td class="normal-weight">${{ calcFilteredPrioABCost(prio, [...procsFilteredReb], "rebuilding") }}</td>
                </tr>
              </tbody>
              <tbody v-if="procsFilteredReb.filter(p => !p.priority && p.priority !== '0').length">
                <!-- procs with no priority level -->
                <tr v-for="proc in procsFilteredReb.filter(p => !p.priority && p.priority !== '0')">
                  <td>-</td>
                  <td>
                    <span v-if="locationProcCats[`${proc.ProcCode}`] && locationProcCats[`${proc.ProcCode}`].friendly_desc" class="desc-friendly"> {{ locationProcCats[`${proc.ProcCode}`].friendly_desc }}</span>
                    <span class="desc" v-else>{{ proc.Descript }}</span>
                    <span v-if="proc.ToothNumTP" class="tooth">, tooth: {{ proc.ToothNumTP }}</span>
                  </td>
                  <td>${{ proc.FeeAmt.toFixed(2) }}</td>
                  <td v-if="location && activeHaFeeSchedName && location[activeHaFeeSchedName] && location[activeHaFeeSchedName][proc.ProcCode]" class="ha-highlight">{{ location[activeHaFeeSchedName][proc.ProcCode].FeeAmount }}</td>
                  <td v-else>${{ proc.PatAmt.toFixed(2) }}</td>
                </tr>
                <!-- show subtotal only if there are also subtotals by priority -->
                <tr class="subtot-internal" v-if="procsRebPrios && procsRebPrios.length">
                  <td colspan="2" class="normal-weight">Subtotal for Remaining</td>
                  <td class="normal-weight">${{ calcFilteredPrioCost(null, [...procsFilteredReb]) }}</td>
                  <td class="normal-weight">${{ calcFilteredPrioABCost(null, [...procsFilteredReb], "advancing") }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr v-if="procsRebPromoTot">
                  <td></td>
                  <td>Save 5% on Rebuilding Care when paid up front</td>
                  <td></td>
                  <td>-${{ procsRebPromoTot.toFixed(2) }}</td>
                </tr>
                <tr class="subtot">
                  <td>Subtotal</td>
                  <td></td>
                  <td>${{ procsRebCostTot.toFixed(2) }}</td>
                  <td>${{ procsRebABTot.toFixed(2) }}</td>
                </tr>
              </tfoot>
            </table>
          </div> <!-- /.col -->
        </div> <!-- /.row -->

        
        <div v-if="procsFilteredProt && procsFilteredProt.length && (!hasPromoProt || (hasPromoProt && procsFilteredProt.length>1))" class="row row-section row-section-prot">
          <button @click="showTxtProt=!showTxtProt" class="col-12 btn btn-section btn-section-prot d-flex justify-content-end align-items-center">
            <h2>Protection Care</h2>
            <p class="ml-auto"><em>(click to <span v-if="showTxtProt">collapse</span><span v-if="!showTxtProt">expand</span>)</em></p>
            <h3>Why should I care?</h3>
            <i v-if="showTxtProt" class="fas fa-minus-square"></i>
            <i v-if="!showTxtProt" class="fas fa-plus-square"></i>
          </button>
          <div v-if="showTxtProt" class="col col-12 col-lg-4">
            <img src="../assets/img/icon-path-step-end.svg" alt="why/care" width="50px" height="50px">
            <h3>after more urgent problems.</h3>
            <h3>get back what you lost.</h3>
          </div> <!-- /.col -->
          <div v-if="showTxtProt"class="col col-12 col-lg-4">
            <h2>Why</h2>
            <hr class="hr-salmon">
            <ul class="icon-list icon-list-warnings">
              <li>If you have a history of a disease, you are at risk for future problems.</li>
              <li>Disease around roots, in grooves, and around the edges of old dental work is expensive.</li>
            </ul>
          </div> <!-- /.col -->
          <div v-if="showTxtProt" class="col col-12 col-lg-4">
            <h2>Care</h2>
            <hr class="hr-green">
            <ul class="icon-list icon-list-checks-circle">
              <li>Save money. Fixing problems later is more expensive than preventing them now. Protection services are highly affordable even without insurance.</li>
              <li>Fluoride varnish can reduce the risk of cavities by <strong>37% in primary teeth</strong> and <strong>43% in permanent teeth</strong>.</li>
              <li>Every <strong>$1 spent on fluoride varnish</strong> can save up to <strong>$38 in future dental treatment costs</strong>. Preventing a cavity with fluoride varnish is <strong>5-10 times cheaper</strong> than treating one.</li>
              <li><strong>Sealing a tooth</strong> reduces risk of cavity by 80% in first two years and can provide protection for up to 9 years. Every <strong>$1 spent on sealants</strong> can save <strong>$11-14 in future restorative costs.</strong></li>
              <li>Fluoride varnish can reduce the risk of cavities by <strong>37% in primary teeth</strong> and <strong>43% in permanent teeth</strong>.</li>
            </ul>
          </div> <!-- /.col -->
        </div>
        <div v-if="procsFilteredProt && procsFilteredProt.length && (!hasPromoProt || (hasPromoProt && procsFilteredProt.length>1))" class="row row-table">
          <div class="col-xl-8 col-lg-10 col-12 offset-xl-2 offset-lg-1">
            <table class="table table-app table-category">
              <thead>
                <tr>
                  <th>Priority</th>
                  <th>Procedure Description</th>
                  <th>Cost</th>
                  <th>After Benefits</th>
                </tr>
              </thead>
              <tbody v-for="prio in procsProtPrios">
                <tr v-for="proc in procsFilteredProt.filter(p => p.priority == prio)">
                  <td><span v-if="proc.priority">{{ proc.priority }}</span><span v-if="!proc.priority">-</span></td>
                  <td>
                    <span v-if="locationProcCats[`${proc.ProcCode}`] && locationProcCats[`${proc.ProcCode}`].friendly_desc" class="desc-friendly"> {{ locationProcCats[`${proc.ProcCode}`].friendly_desc }}</span>
                    <span class="desc" v-else>{{ proc.Descript }}</span>
                    <span v-if="proc.ToothNumTP" class="tooth">, tooth: {{ proc.ToothNumTP }}</span>
                  </td>
                  <td>${{ proc.FeeAmt.toFixed(2) }}</td>
                  <td v-if="location && activeHaFeeSchedName && location[activeHaFeeSchedName] && location[activeHaFeeSchedName][proc.ProcCode]" class="ha-highlight">{{ location[activeHaFeeSchedName][proc.ProcCode].FeeAmount }}</td>
                  <td v-else>${{ proc.PatAmt.toFixed(2) }}</td>
                </tr>
                <!-- show subtotal only if there are multiple subtotals by priority or a subtotal for remaining -->
                <tr class="subtot-internal" v-if="(procsProtPrios && procsProtPrios.length && procsProtPrios.length > 1) || procsFilteredProt.filter(p => !p.priority && p.priority !== '0').length">
                  <td colspan="2" class="normal-weight">Subtotal for Priority {{ prio }}</td>
                  <td class="normal-weight">${{ calcFilteredPrioCost(prio, [...procsFilteredProt]) }}</td>
                  <td class="normal-weight">${{ calcFilteredPrioABCost(prio, [...procsFilteredProt], "protection") }}</td>
                </tr>
              </tbody>
              <tbody v-if="procsFilteredProt.filter(p => !p.priority && p.priority !== '0').length">
                <!-- procs with no priority level -->
                <tr v-for="proc in procsFilteredProt.filter(p => !p.priority && p.priority !== '0')">
                  <td>-</td>
                  <td>
                    <span v-if="locationProcCats[`${proc.ProcCode}`] && locationProcCats[`${proc.ProcCode}`].friendly_desc" class="desc-friendly"> {{ locationProcCats[`${proc.ProcCode}`].friendly_desc }}</span>
                    <span class="desc" v-else>{{ proc.Descript }}</span>
                    <span v-if="proc.ToothNumTP" class="tooth">, tooth: {{ proc.ToothNumTP }}</span>
                  </td>
                  <td>${{ proc.FeeAmt.toFixed(2) }}</td>
                  <td v-if="location && activeHaFeeSchedName && location[activeHaFeeSchedName] && location[activeHaFeeSchedName][proc.ProcCode]" class="ha-highlight">{{ location[activeHaFeeSchedName][proc.ProcCode].FeeAmount }}</td>
                  <td v-else>${{ proc.PatAmt.toFixed(2) }}</td>
                </tr>
                <!-- show subtotal only if there are also subtotals by priority -->
                <tr class="subtot-internal" v-if="procsProtPrios && procsProtPrios.length">
                  <td colspan="2" class="normal-weight">Subtotal for Remaining</td>
                  <td class="normal-weight">${{ calcFilteredPrioCost(null, [...procsFilteredProt]) }}</td>
                  <td class="normal-weight">${{ calcFilteredPrioABCost(null, [...procsFilteredProt], "advancing") }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr v-if="procsProtPromoTot">
                  <td></td>
                  <td>Save 10% on Protection Care after advancing &amp; rebuilding care completed</td>
                  <td></td>
                  <td>-${{ procsProtPromoTot.toFixed(2) }}</td>
                </tr>
                <tr class="subtot">
                  <td>Subtotal</td>
                  <td></td>
                  <td>${{ procsProtCostTot.toFixed(2) }}</td>
                  <td>${{ procsProtABTot.toFixed(2) }}</td>
                </tr>
              </tfoot>
            </table>
          </div> <!-- /.col -->
        </div> <!-- /.row -->

        <div class="w-100 col-summary-title">
          <h2>Summary</h2>
          <hr class="hr-dark-color hr-thick">
          <p v-if="patGoal && patGoal.length" v-for="pg in patGoal" class="patient-goal text-center"><patient-goal :patGoal="pg"></patient-goal></p>
        </div>
        <div class="row row-table">
          <div class="col-xl-8 col-lg-10 col-12 offset-xl-2 offset-lg-1">
            <table class="table table-app table-summary">
              <thead>
                <tr>
                  <th>Category</th>
                  <th>Cost</th>
                  <th>After Benefits</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="procsAdvCostTot && procsAdvABTot">
                  <td>Advancing Disease Care</td>
                  <td>${{ procsAdvCostTot.toFixed(2) }}</td>
                  <td>${{ procsAdvABTot.toFixed(2) }}</td>
                </tr>
                <tr v-if="procsRebCostTot && procsRebABTot">
                  <td>Rebuilding Care</td>
                  <td>${{ procsRebCostTot.toFixed(2) }}</td>
                  <td>${{ procsRebABTot.toFixed(2) }}</td>
                </tr>
                <tr v-if="procsProtCostTot && procsProtABTot">
                  <td>Protection Care</td>
                  <td>${{ procsProtCostTot.toFixed(2) }}</td>
                  <td>${{ procsProtABTot.toFixed(2) }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td>Total</td>
                  <td>${{ (procsAdvCostTot + procsRebCostTot + procsProtCostTot).toFixed(2) }}</td>
                  <td>${{ (procsAdvABTot + procsRebABTot + procsProtABTot).toFixed(2) }}</td>
                </tr>
              </tfoot>
            </table>
          </div> <!-- /.col -->
        </div> <!-- /.row -->
        
        <div class="row">
          <button v-if="hasPromoAdv && procsFilteredAdv && procsFilteredAdv.length>1" @click="applyPromoAdv=!applyPromoAdv" class="col-xl-8 col-lg-10 offset-xl-2 offset-lg-1 d-flex justify-content-between align-items-center proc-promo proc-promo-adv text-left">
            <span v-if="!applyPromoAdv" class="proc-promo-float"><em>click to apply</em></span>
            <span v-if="applyPromoAdv" class="proc-promo-float color-green"><i class="fas fa-check"></i></span>
            <div>
              <h1>Save 10%</h1>
              <p>Advancing Disease Care</p>
            </div>
            <p><strong>10% off any procedures in this group completed today or tomorrow.</strong> We believe this care is so important that we'll give you this discount in account credit if completed in the next two appointment days.</p>
          </button> <!-- /.col -->
          <button v-if="hasPromoReb && procsFilteredReb && procsFilteredReb.length>1" @click="applyPromoReb=!applyPromoReb" class="col-xl-8 col-lg-10 offset-xl-2 offset-lg-1 d-flex justify-content-between align-items-center proc-promo proc-promo-reb text-left">
            <span v-if="!applyPromoReb" class="proc-promo-float"><em>click to apply</em></span>
            <span v-if="applyPromoReb" class="proc-promo-float color-green"><i class="fas fa-check"></i></span>
            <div>
              <h1>Save 5%</h1>
              <p>Rebuilding Care</p>
            </div>
            <p><strong>5% off procedures in this group when when paid up front.</strong> We know this care can be expensive and isn't always covered by insurance, so here's some help.</p>
          </button> <!-- /.col -->
          <button v-if="hasPromoProt && procsFilteredProt && procsFilteredProt.length>1" @click="applyPromoProt=!applyPromoProt" class="col-xl-8 col-lg-10 offset-xl-2 offset-lg-1 d-flex justify-content-between align-items-center proc-promo proc-promo-prot text-left">
            <span v-if="!applyPromoProt" class="proc-promo-float"><em>click to apply</em></span>
            <span v-if="applyPromoProt" class="proc-promo-float color-green"><i class="fas fa-check"></i></span>
            <div>
              <h1>Save 10%</h1>
              <p>Protection Care</p>
            </div>
            <p><strong>10% off any procedures in this group after you've completed advancing &amp; rebuilding care.</strong></p>
          </button> <!-- /.col -->
          <button v-if="hasHAFeeScheds && !showHATable" @click="showHATable=true" class="col-xl-8 col-lg-10 offset-xl-2 offset-lg-1 d-flex align-items-center proc-promo proc-promo-ha text-center">
            <div>
              <h3>No insurance?</h3>
              <h1>Save Up To 45% with<br class="hidden visible-md"> a Membership</h1>
              <h3 class="normal-weight"><i class="fas fa-plus-square"></i> click here to expand & see discounts</h3>
            </div>
          </button> <!-- /.col -->
        </div> <!-- /.row -->

        <p v-if="showHATable" class="text-center swipe-indicator dark-color text-center"><i class="far fa-long-arrow-left"></i> swipe to see all plans <i class="far fa-long-arrow-right"></i></p>
        <div v-if="showHATable && primaryPlans && Object.keys(primaryPlans).length" class="plans-table row">
          <div class="col-12 col-close-table"><button @click="showHATable=false" class="btn btn-link col-12 text-center"><small><i class="fas fa-fw fa-times"></i>close table</small></button></div>
          <div class="plans-table-inner col-12">
            <div class="row row-plans-header">
              <div v-for="(plan, index) in primaryPlans" class="col">
                <h4>{{ plan.name }}</h4>
              </div>
            </div> <!-- /.row -->

            <div class="row row-dk">
              <div class="col">
                <p>Who is this good for?</p>
              </div>
            </div> <!-- /.row -->
            <div class="row row-plans-benefits">
              <div v-for="(plan, index) in primaryPlans" class="col benefits" v-html="plan.benefits_patient_type"></div>
            </div> <!-- /.row -->

            <div class="row row-dk">
              <div class="col">
                <p>Preventative Health Services</p>
              </div>
            </div> <!-- /.row -->
            <div class="row row-plans-benefits">
              <div v-for="(plan, index) in primaryPlans" class="col benefits" v-html="plan.benefits_preventative"></div>
            </div> <!-- /.row -->

            <div class="row row-dk">
              <div class="col">
                <p>Health Restorative Services</p>
              </div>
            </div> <!-- /.row -->
            <div class="row row-plans-benefits">
              <div v-for="(plan, index) in primaryPlans" class="col benefits" v-html="plan.benefits_restorative"></div>
            </div> <!-- /.row -->

            <div class="row row-dk">
              <div class="col">
                <p>Special Additions</p>
              </div>
            </div> <!-- /.row -->
            <div class="row row-plans-benefits">
              <div v-for="(plan, index) in primaryPlans" class="col benefits" v-html="plan.benefits_special"></div>
            </div> <!-- /.row -->

            <div class="row row-dk">
              <div class="col">
                <p>Pricing Per Person</p>
              </div>
            </div> <!-- /.row -->
            <div class="row row-plans-benefits">
              <div v-for="(plan, index) in primaryPlans" class="col">
                <p v-for="price in plan.prices" v-if="!price.archived" class="plan-price">${{ price.amount/100 }} / {{ price.interval }}</p>
                <hr class="ha-table-footer">
                <p class="snug text-center">
                  <button v-if="activeHaPlan!==plan.name" @click="activateHaPlan(plan.name)" class="btn btn-app btn-lg">Preview Discounts</button>
                  <button v-if="activeHaPlan==plan.name" class="btn btn-light btn-lg btn-icon-left" @click="activeHaPlan=null"><i class="fas fa-check color-green"></i> Applied</button>
                </p>
              </div>
            </div> <!-- /.row -->
          </div> <!-- /.plans-table-inner -->
          <div class="col-12 col-close-table"><button @click="showHATable=false" class="btn btn-link col-12 text-center"><small><i class="fas fa-fw fa-times"></i>close table</small></button></div>
        </div> <!-- /.plans-table -->


        <h2 class="text-center">More Cost-Saving Options</h2>
        <div class="row-cost-saving row justify-content-center">
          <div class="col-12 col-xl-5 col-lg-6">
            <div class="cost-box cost-box-financing">
              <h1>You don't have to pay it all up front.</h1>
              <h3>Learn about our <br>financing options.</h3>
              <p>We offer affordable financing with no hard credit check.</p>
              <p v-if="imgUrlQrFinancing">Scan here to see options:</p>
              <img class="img-svg" v-if="imgUrlQrFinancing" :src="imgUrlQrFinancing" alt="qr-code" width="150px" height="150px">
            </div>
          </div> <!-- /.col -->
          <div class="col-12 col-xl-5 col-lg-6">
            <div class="cost-box cost-box-ha">
              <h3>No insurance?</h3>
              <h1>Save Up To 45% with a Membership</h1>
              <p><img src="../assets/img/logo-health-assurance@2x.png" alt="health assurance" width="151px" height="53px"></p>
              <p>Get free preventative care and a discount on other services, with plans based on your needs.</p>
              <p v-if="imgUrlQrHA">Scan here to browse plans:</p>
              <img class="img-svg" v-if="imgUrlQrHA" :src="imgUrlQrHA" alt="qr-code" width="150px" height="150px">
            </div>
          </div> <!-- /.col -->
        </div> <!-- /.row -->

      </div> <!-- /.col -->

      <div v-if="treatPlanData && treatPlanData.length" class="col-sign col-xl-8 col-lg-10 offset-xl-2 offset-lg-1">
        <h1 class="text-center">Please Sign Here to Confirm You Understand Your Treatment Plan</h1>
        <h3 class="text-center">Signing does not obligate you to pursue treatment, and serves as a record that we presented you with your treatment options.</h3>
        <label class="normal-weight form-check">
          <input type="checkbox" name="acceptedTerms" v-model="acceptedTerms" value="acceptedTerms" class="form-check-input">
          <p>I understand that the amount due is my responsibility and that insurance is billed as a courtesy to assist me in paying my obligation. I understand that insurance figures provided are estimates only.  I understand that this estimate is NOT a guarantee of payment by my insurance.  If the insurance company pays more, I will receive a refund.  If the insurance company pays less, I will  receive a bill for the difference or have my payment plan extended.  I understand that if my insurance company fails to pay within 60 days of the claim being submitted, the full amount due is my responsibility.  I understand that the above estimated fees are based on my treatment plan as listed above.  The treatment plan may change, altering the total cost of care. I understand the practice reserves the right to charge me a $40 cancellation fee if I cancel an appointment later than 10am the previous business day.</p>

        </label>
        <label class="normal-weight form-check">
          <input type="checkbox" name="acknowledgedPlanOptions" v-model="acknowledgedPlanOptions" value="acknowledgedPlanOptions" class="form-check-input">
          <p>Treatment plan options have been presented to me.  I understand my options and acknowledge I have had the opportunity to have all my questions answered and have received a copy today. I understand that my insurance benefit will not pay towards any upgraded service(s) that I selected and I understand that I will be responsible for the fee for this treatment I selected. I understand that I am waiving my insurance plan guidelines and I release the rendering provider from the contractual terms of my plan.</p>
        </label>
        <label class="normal-weight form-check">
          <input type="checkbox" name="acknowledgedInsuranceCoverage" v-model="acknowledgedInsuranceCoverage" value="acknowledgedInsuranceCoverage" class="form-check-input">
          <p>I understand my provider and dental team have recommended treatment that my Insurance Company will not cover at 100%.  I elect to receive this treatment and understand that both the added value service and associated fees will not be covered by my insurance plan. The treatment cost listed above is Usual, Customary, and Reasonable rate for the upgraded treatment I elect to receive.  Due to the advanced cosmetic and aesthetic nature of the materials and/or techniques used for this treatment I understand that this elective service is not always completely covered by my dental insurance. By accepting this fee, Renken Dentistry will also guarantee any lab work for 1 year.</p>
        </label>
        <p>My signature below indicates I have read and understand the "Financial Agreement for Dental Treatment - Material Upgrade".  I understand I am responsible for this additional fee listed above, as well as any fees associated with the recommended treatment.</p>
        <div ref="signatureContainer" class="signature-container" @mouseup="updateSignatureEmpty" @touchend="updateSignatureEmpty">
          <vueSignature :key="signatureKey" ref="signature" :w="signatureWidth" :h="'200px'"></vueSignature>
        </div>
        <div class="row signature-instructions">
          <div class="col-md-8 col-6">
            <p><small><em>Use your mouse or finger to draw your signature above</em></small></p>
          </div>
          <div class="col-md-4 col-6 text-right">
            <button class="btn btn-link btn-sm" @click.prevent="clearSignature">Clear Signature</button>
          </div>
        </div>
        <label>Type your full name:</label>
        <input v-model="signeeName" name="signeeName" :class="{'pb-0': loadingImageUpload}" class="form-control" placeholder="Enter name" type="text"/>
        <p class="text-center" v-if="!loadingImageUpload && !successImageUpload"><button :disabled="!acceptedTerms || !acknowledgedPlanOptions || !acknowledgedInsuranceCoverage || !signeeName || signatureEmpty" @click.prevent="saveSignedPlan" class="btn btn-green btn-lg">Save Signature<i class="fas fa-angle-right fa-fw"></i></button></p>
        <p v-if="loadingImageUpload || !treatment_plan || !treatPlanData" class="light-weight text-center">
          <i class="far fa-fw fa-pulse fa-spinner"></i><br>
          <small>saving, please wait</small>
        </p>
        <list-errors :errors="uploadErrors" class="text-center"></list-errors>
        <p v-if="successImageUpload" class="color-green text-center"><i class="fas fa-check"></i> success!</p>
        <p v-if="successImageUpload" class="text-center"><button class="btn btn-green" @click="closePlan"> Close Treatment Plan <i class="fas fa-times"></i></button></p>
      </div> <!-- /.col -->


    </div> <!-- /.row -->
  </layout-private>
</template>

<script>
import Vue from 'vue'
import LayoutPrivate from '../components/LayoutPrivate.vue'
import {mapGetters} from 'vuex'
import ListErrors from '../components/ListErrors.vue'
import PatientGoal from '../components/PatientGoal.vue'
import ImageGallery from '../components/ImageGallery.vue'
import store from '../store'
import vueSignature from "vue-signature"
import html2canvas from "html2canvas"
import moment from 'moment-timezone';
import haPlans from "../assets/json/ha-plans.json";

export default {
  props: ['customer'],
  components: {
    LayoutPrivate, ListErrors, vueSignature, PatientGoal, ImageGallery,
  },
  data () {
    return {
      errors: [],
      uploadErrors: [],
      loading: true,
      treatPlanData: null,
      showTxtAdv: false,
      showTxtReb: false,
      showTxtProt: false,
      imgUrlQrFinancing: null,
      imgUrlQrHA: null,
      acceptedTerms: false,
      acknowledgedPlanOptions: false,
      acknowledgedInsuranceCoverage: false,
      signeeName: null,
      loadingImageUpload: false,
      loadingUnsignedImageUpload: false,
      successImageUpload: false,
      successUnsignedImageUpload: false,
      locationProcCats: null,
      patGoal : null,
      patNum: null,
      location: null,
      // vue-signature
      signatureWidth: '825',
      resizeTimeout: null,
      signatureKey: 0, // key for signature component to destroy & recycle it after screen resizes so the canvas will be resized
      signatureEmpty: true,
      // apply promos
      applyPromoAdv: false,
      applyPromoReb: false,
      applyPromoProt: false,
      // HA table & discounts
      showHATable : false,
      activeHaPlan: null,
      primaryPlans: haPlans,
    }
  },
  computed: {
    ...mapGetters(['user', 'user_props', 'custom_claims', 'treatment_plan', 'pat_num', 'pat_name']),
    environment() {
      if(process.env.VUE_APP_ENV === "staging") {
        return "staging";
      }
      if(process.env.NODE_ENV === "production") {
        return "production";
      }
      if(process.env.NODE_ENV === "development" || process.env.VUE_APP_ENV === "test") {
        return "development";
      }
    },
    // HA
    hasHAFeeScheds() {
      if(this.location && (this.location.od_feesched_ha_basic || this.location.od_feesched_ha_creator || this.location.od_feesched_ha_rebuild)) {
        return true;
      }
      return false;
    },
    activeHaFeeSchedName () {
      const feeSchedNameByPlanName = {
        "Basic Support": "od_feesched_ha_basic",
        "Health Creator": "od_feesched_ha_creator",
        "Health Rebuilding": "od_feesched_ha_rebuild",
      };
      if(this.activeHaPlan) {
        return feeSchedNameByPlanName[this.activeHaPlan];
      }
      return null;
    },
    //  Promos
    hasPromoAdv() {
      // testing only:
      // return true;
      if(this.treatPlanData && this.treatPlanData.length && this.treatPlanData.some(tp => tp.ProcCode == "10%sameday")) {
        return true;
      }
      return false;
    },
    hasPromoReb() {
      // testing only:
      // return true;
      if(this.treatPlanData && this.treatPlanData.length && this.treatPlanData.some(tp => tp.ProcCode == "5%rebuilding")) {
        return true;
      }
      return false;
    },
    hasPromoProt() {
      // testing only:
      // return true;
      if(this.treatPlanData && this.treatPlanData.length && this.treatPlanData.some(tp => tp.ProcCode == "10%protectcare")) {
        return true;
      }
      return false;
    },
    procsFilteredAdv() {
      if(this.treatPlanData && this.treatPlanData.length && this.locationProcCats) {
        return this.treatPlanData.filter(tp => this.locationProcCats[`${tp.ProcCode}`] && (this.locationProcCats[`${tp.ProcCode}`]=="advancing" || this.locationProcCats[`${tp.ProcCode}`].category_code=="advancing")).sort(this.sortByPriority);
      }
      return null;
    },
        procsAdvPrios() {
          // return array of unique priority levels within the filtered array
          if(this.procsFilteredAdv && this.procsFilteredAdv.length) {
            const prioMap = this.procsFilteredAdv.reduce((map, item) => {
              if(item.priority && item.priority !== "") {
                map.set(item.priority, true); // set val as boolean for placeholder
              }
              return map;
            }, new Map());
            return Array.from(prioMap.keys());
          }
          return null;
        },
        procsAdvPromoTot() {
          if(this.procsFilteredAdv && this.procsFilteredAdv.length && this.applyPromoAdv) {
            return this.procsFilteredAdv.reduce((tot,next) => tot + next.PatAmt, 0) * 0.1;
          }
          return 0;
        },
        procsAdvCostTot() {
          if(this.procsFilteredAdv && this.procsFilteredAdv.length) {
            return this.procsFilteredAdv.reduce((tot,next) => tot + next.FeeAmt, 0);
          }
          return null;
        },
        procsAdvABTot() {
          if(this.procsFilteredAdv && this.procsFilteredAdv.length) {
            // if HA applied, use HA fee schedule amounts
            if(this.activeHaPlan && this.location && this.activeHaFeeSchedName && this.location[this.activeHaFeeSchedName]) {
              // add each proc's HA fee to running total
              return this.procsFilteredAdv.reduce((tot,next) => {
                if(next.ProcCode && this.location[this.activeHaFeeSchedName][next.ProcCode] && this.location[this.activeHaFeeSchedName][next.ProcCode].FeeAmount) {
                  return tot + this.location[this.activeHaFeeSchedName][next.ProcCode].FeeAmount
                }
                return tot + next.PatAmt;
              }, 0) - this.procsAdvPromoTot;
            } else {
              // else, use PatAmt
              return this.procsFilteredAdv.reduce((tot,next) => tot + next.PatAmt, 0) - this.procsAdvPromoTot;
            }
          }
          return null;
        },
    procsFilteredReb() {
      if(this.treatPlanData && this.treatPlanData.length && this.locationProcCats) {
        return this.treatPlanData.filter(tp => this.locationProcCats[`${tp.ProcCode}`] && (this.locationProcCats[`${tp.ProcCode}`]=="rebuilding" || this.locationProcCats[`${tp.ProcCode}`].category_code=="rebuilding")).sort(this.sortByPriority);
      }
      return null;
    },
        procsRebPrios() {
          // return array of unique priority levels within the filtered array
          if(this.procsFilteredReb && this.procsFilteredReb.length) {
            const prioMap = this.procsFilteredReb.reduce((map, item) => {
              if(item.priority && item.priority !== "") {
                map.set(item.priority, true); // set val as boolean for placeholder
              }
              return map;
            }, new Map());
            return Array.from(prioMap.keys());
          }
          return null;
        },
        procsRebPromoTot() {
          if(this.procsFilteredReb && this.procsFilteredReb.length && this.applyPromoReb) {
            // calculate 5% of after benefits
            return this.procsFilteredReb.reduce((tot,next) => tot + next.PatAmt, 0) * 0.05;
          }
          return 0;
        },
        procsRebCostTot() {
          if(this.procsFilteredReb && this.procsFilteredReb.length) {
            return this.procsFilteredReb.reduce((tot,next) => tot + next.FeeAmt, 0);
          }
          return null;
        },
        procsRebABTot() {
          if(this.procsFilteredReb && this.procsFilteredReb.length) {
            // if HA applied, use HA fee schedule amounts
            if(this.activeHaPlan && this.location && this.activeHaFeeSchedName && this.location[this.activeHaFeeSchedName]) {
              // add each proc's HA fee to running total
              return this.procsFilteredReb.reduce((tot,next) => {
                if(next.ProcCode && this.location[this.activeHaFeeSchedName][next.ProcCode] && this.location[this.activeHaFeeSchedName][next.ProcCode].FeeAmount) {
                  return tot + this.location[this.activeHaFeeSchedName][next.ProcCode].FeeAmount
                }
                return tot + next.PatAmt;
              }, 0) - this.procsRebPromoTot;
            } else {
              // else, use PatAmt
              return this.procsFilteredReb.reduce((tot,next) => tot + next.PatAmt, 0) - this.procsRebPromoTot;
            }
          }
          return null;
        },
    procsFilteredProt() {
      if(this.treatPlanData && this.treatPlanData.length && this.locationProcCats) {
        return this.treatPlanData.filter(tp => this.locationProcCats[`${tp.ProcCode}`] && (this.locationProcCats[`${tp.ProcCode}`]=="protection" || this.locationProcCats[`${tp.ProcCode}`].category_code=="protection")).sort(this.sortByPriority);
      }
      return null;
    },
        procsProtPrios() {
          // return array of unique priority levels within the filtered array
          if(this.procsFilteredProt && this.procsFilteredProt.length) {
            const prioMap = this.procsFilteredProt.reduce((map, item) => {
              if(item.priority && item.priority !== "") {
                map.set(item.priority, true); // set val as boolean for placeholder
              }
              return map;
            }, new Map());
            return Array.from(prioMap.keys());
          }
          return null;
        },
        procsProtPromoTot() {
          if(this.procsFilteredProt && this.procsFilteredProt.length && this.applyPromoProt) {
            // calculate 10% of after benefits
            return this.procsFilteredProt.reduce((tot,next) => tot + next.PatAmt, 0) * 0.1;
          }
          return 0;
        },
        procsProtCostTot() {
          if(this.procsFilteredProt && this.procsFilteredProt.length) {
            return this.procsFilteredProt.reduce((tot,next) => tot + next.FeeAmt, 0);
          }
          return null;
        },
        procsProtABTot() {
          if(this.procsFilteredProt && this.procsFilteredProt.length) {
            // return this.procsFilteredProt.reduce((tot,next) => tot + next.PatAmt, 0) - this.procsProtPromoTot;
            // if HA applied, use HA fee schedule amounts
            if(this.activeHaPlan && this.location && this.activeHaFeeSchedName && this.location[this.activeHaFeeSchedName]) {
              // add each proc's HA fee to running total
              return this.procsFilteredProt.reduce((tot,next) => {
                if(next.ProcCode && this.location[this.activeHaFeeSchedName][next.ProcCode] && this.location[this.activeHaFeeSchedName][next.ProcCode].FeeAmount) {
                  return tot + this.location[this.activeHaFeeSchedName][next.ProcCode].FeeAmount
                }
                return tot + next.PatAmt;
              }, 0) - this.procsProtPromoTot;
            } else {
              // else, use PatAmt
              return this.procsFilteredProt.reduce((tot,next) => tot + next.PatAmt, 0) - this.procsProtPromoTot;
            }
          }
          return null;
        },
  },
  watch: {
    treatment_plan() {
      if(this.treatment_plan && this.treatment_plan.TreatPlanNum) {
        this.loadPlanData();
        this.loadLocation();
        // this.loadPatGoal();
      }
    },
    custom_claims() {
      if(this.custom_claims && this.custom_claims.customerId && this.custom_claims.authorized_location) {
        this.loadPhoto(`/customers/${this.custom_claims.customerId}/locations/${this.custom_claims.authorized_location}/qr-financing-${this.custom_claims.authorized_location}.png`,'imgUrlQrFinancing');
        this.loadPhoto(`/customers/${this.custom_claims.customerId}/locations/${this.custom_claims.authorized_location}/qr-HA-${this.custom_claims.authorized_location}.png`,'imgUrlQrHA');
      }
    },
    pat_num() {
      if(this.pat_num) {
        this.patNum = this.pat_num;
        this.loadPatGoal();
      }
    },
    // when a promo activates, disable HA
    applyPromoAdv() {
      if(this.applyPromoAdv) {
        this.activeHaPlan = null;
      }
    },
    applyPromoReb() {
      if(this.applyPromoReb) {
        this.activeHaPlan = null;
      }
    },
    applyPromoProt() {
      if(this.applyPromoProt) {
        this.activeHaPlan = null;
      }
    },
  },
  methods: {
    calcFilteredPrioCost (prio, arr) {
      // supports null value for prio to calc for procs with no priority set
      if(!arr || !arr.length) {
        return null;
      }
      // console.log('calcFilteredPrioCost -----');
      // console.log({prio});
      // console.log({arr});
      let matches;
      if(prio){
        matches = arr.filter(proc => proc.priority == prio);
      } else {
        matches = arr.filter(proc => !proc.priority);
      }
      // console.log({matches});
      let filteredTot = matches.reduce((tot, current) => {return tot + current.FeeAmt}, 0)
      // console.log({filteredTot});
      return filteredTot.toFixed(2);
    },
    calcFilteredPrioABCost (prio, arr, sectionName) {
      // supports null value for prio to calc for procs with no priority set
      if(!arr || !arr.length || !sectionName) {
        return null;
      }
      // console.log('calcFilteredPrioABCost -----');
      // console.log({prio});
      // console.log({arr});
      let matches;
      if(prio){
        matches = arr.filter(proc => proc.priority == prio);
      } else {
        matches = arr.filter(proc => !proc.priority);
      }
      // console.log({matches});
      let filteredTot;
      // calculate promo discount
      let discount = 0;
      let discountsBySectionName = {
        advancing: 0.1,
        rebuilding: 0.05,
        protection: 0.1,
      }
      // only get discount if one is applied and have a matching value
      if( (this.applyPromoAdv && sectionName == "advancing") || (this.applyPromoReb && sectionName == "rebuilding") || (this.applyPromoProt && sectionName == "protection") ) {
        discount = discountsBySectionName[sectionName];
      }
      // console.log({discount});

      // reuse from procsAdvABTot
      // if HA applied, use HA fee schedule amounts
      if(this.activeHaPlan && this.location && this.activeHaFeeSchedName && this.location[this.activeHaFeeSchedName]) {
        // add each proc's HA fee to running total
        filteredTot = matches.reduce((tot,next) => {
          if(next.ProcCode && this.location[this.activeHaFeeSchedName][next.ProcCode] && this.location[this.activeHaFeeSchedName][next.ProcCode].FeeAmount) {
            return tot + this.location[this.activeHaFeeSchedName][next.ProcCode].FeeAmount
          }
          return tot + next.PatAmt;
        }, 0);
      } else {
        // else, use PatAmt
        filteredTot = matches.reduce((tot,next) => tot + next.PatAmt, 0);
      }
      // console.log({filteredTot});
      filteredTot = filteredTot  * (1 - discount);
      // console.log({filteredTot});
      return filteredTot.toFixed(2);
    },
    activateHaPlan(planName) {
      const validPlanNames = ["Basic Support","Health Creator","Health Rebuilding"];
      if(validPlanNames.includes(planName)) {
        // disable other promos
        this.applyPromoAdv = false;
        this.applyPromoReb = false;
        this.applyPromoProt = false;
        this.activeHaPlan = planName;
      } else {
        this.activeHaPlan = null;
      }
    },
    // used in procsFilteredAdv, procsFilteredReb, procsFilteredProt
    sortByPriority(prev,next){
      const pPri = prev.priority.toUpperCase() || null;
      const nPri = next.priority.toUpperCase() || null;
      if(!nPri) {
        return -1;
      }
      if(!pPri) {
        return 1;
      }
      // ascending
      // can't compare strings with subtraction here
      if(pPri < nPri) {
        return -1;
      }
      if(pPri > nPri) {
        return 1;
      }
      return 0;
    },
    loadPatGoal() {
      // validate patNum
      if(!this.patNum || !this.patNum.toString().length > 10 || !Number.isInteger(this.patNum)) {
        console.log("loadPatGoal - invalid patNum");
        return;
      }
      // validate required data exists
      if(!this.custom_claims || !this.custom_claims.customerId || !this.custom_claims.authorized_location || !this.user || !this.user.uid) {
        console.log("loadPatGoal - missing required data");
        return;
      }
      // exit if already loaded
      if(this.patGoal) {
        console.log("loadPatGoal - patGoal already loaded");
        return;
      }
      // // testing only
      // // ----------
      // this.patGoal = "Making Teeth Last for the Long Run";
      // return;
      // // ----------
      // use callable function
      var loadPatInfoFunc = Vue.functions.httpsCallable('loadPatientInfo');
      loadPatInfoFunc({
        patNum: this.patNum,
        customerId: this.custom_claims.customerId,
        uid: this.user.uid,
        locationId: this.custom_claims.authorized_location
      })
        .then(result => {
          // console.log('loadPatInfo result',result);
          // this.loading = false;
          if(result && result.data && result.data.length) {
            this.patGoal = result.data;
          } else {
            console.log("no patient info data found for that PatNum");
          }
        })
        .catch(err => {
          this.errors.push(err.message)
          // this.loading = false;
          console.log(err);
        });
    },
    loadLocation() {
      // validate required data exists
      if(!this.custom_claims || !this.custom_claims.customerId || !this.custom_claims.authorized_location || !this.user || !this.user.uid) {
        this.errors.push("You're missing the permissions to load treatment plans. Please contact a team lead.");
      }
      if(this.errors.length) {
        this.loading = false;
        return;
      }
      // exit if already loaded
      if(this.locationProcCats) {
        return;
      }
      Vue.firestore
        .doc(`customers/${this.custom_claims.customerId}/locations/${this.custom_claims.authorized_location}`)
        .get()
        .then(locSnap => {
          if(locSnap.exists && locSnap.data()) {
            // save location except 2nd copy of proc cats
            let loc = locSnap.data();
            delete loc.proc_cats; // yes, this is the correct syntax
            this.location = loc;
            if(locSnap.data().proc_cats) {
              this.locationProcCats = locSnap.data().proc_cats;
            }
            return true;
          }
          console.log('no location data found');
        })
        .catch(err => {
          console.log(err);
          this.errors.push(err.message);
        })
    },
    loadPlanData() {
      this.loading = true;
      this.errors = [];
      // validate treatment_plan
      if(!this.treatment_plan || !this.treatment_plan.TreatPlanNum) {
        this.errors.push("Invalid Treatment Plan.");
      }
      // validate required data exists
      if(!this.custom_claims || !this.custom_claims.customerId || !this.custom_claims.authorized_location || !this.user || !this.user.uid) {
        this.errors.push("You're missing the permissions to load treatment plans. Please contact a team lead.");
      }
      if(this.errors.length) {
        this.loading = false;
        return;
      }
      this.treatPlanData = null;
      // use callable function
      var loadPlanDataFunc = Vue.functions.httpsCallable('loadPlanData');
      loadPlanDataFunc({
        TreatPlanNum: this.treatment_plan.TreatPlanNum,
        customerId: this.custom_claims.customerId,
        uid: this.user.uid,
        locationId: this.custom_claims.authorized_location
      })
        .then(result => {
          // console.log('loadPlanData result',result);
          this.loading = false;
          if(result && result.data && result.data.length) {
            this.treatPlanData = result.data;
          } else {
            this.errors.push("no treatment plan data found for that Plan Number");
          }
        })
        .catch(err => {
          this.errors.push(err.message)
          this.loading = false;
          console.log(err);
        });
    },
    loadPhoto (storagePath,varName) {
      if(!storagePath) {
        return;
      }
      // console.log(`loading photo ${varName} at ${storagePath}`);
      Vue.storage.ref().child(storagePath).getDownloadURL()
        .then((result) => {
          // only show if correct filetype
          if(result.includes('.jpg') || result.includes('.jpeg') || result.includes('.png') || result.includes('.gif') || result.includes('.svg')) {
            // this[varName] = result;
            return fetch(result);
          }
          console.error('image url not found');
          return false;
        })
        .then(response => {
          if(response) {
            return response.blob();
          }
          console.error("couldn't fetch image");
          return false;
        })
        .then(blob => {
          if(blob) {
            this[varName] = URL.createObjectURL(blob);
            return true;
          }
        })
        .catch(e => console.log(e));
    },
    scrollToPlan() {
      // scroll down
      this.$refs.tpTitle.scrollIntoView({behavior: 'smooth'});
    },
    closePlan() {
      store.dispatch('clearTreatmentPlan');
      store.dispatch('clearPatNum');
      store.dispatch('clearPatName');
      this.$router.push('/')
    },
    async saveUnsignedPlan () {
      console.log('saveUnsignedPlan');
      this.savePlan("unsigned");
    },
    async saveSignedPlan () {
      console.log("saveSignedPlan");
      await this.savePlan("signatures");
      // if this page is shown inside an encounter, emit forward event after saving
      if(this.$route.name === "appointmentTreatSummary") {
        // this.$emit('tp-signed');
        this.$emit('forward');
      }
    },
    async savePlan(subFolderName) {
      this.uploadErrors = [];
      if(subFolderName == "signatures") {
        this.loadingImageUpload = true;
      }
      if(subFolderName == "unsigned") {
        this.loadingUnsignedImageUpload = true;
      }
      // validate
      if(!subFolderName || (subFolderName!=="signatures" && subFolderName!=="unsigned")) {
        console.error("missing/incorrect subFolderName");
        return;
      }
      if(!this.custom_claims || !this.custom_claims.customerId || !this.custom_claims.authorized_location) {
        this.uploadErrors.push('Error authenticating user account. Please log out, log in, and try again.')
      }
      if(!this.pat_num) {
        this.uploadErrors.push('No PatNum found, please restart search, and try again.')
      }
      if(!this.treatment_plan || !this.treatment_plan.TreatPlanNum) {
        this.uploadErrors.push('No TreatPlanNum found, please restart search, and try again.')
      }
      // validate for signatures folder only
      if(subFolderName == "signatures") {
        if(!this.acceptedTerms) {
          this.uploadErrors.push('You must check the box to accept the terms in order to sign.')
        }
        if(!this.acknowledgedPlanOptions) {
          this.uploadErrors.push('You must check the box to acknowledge your plan options in order to sign.')
        }
        if(!this.acknowledgedInsuranceCoverage) {
          this.uploadErrors.push('You must check the box to acknowledge insurance coverage terms in order to sign.')
        }
        if(!this.signeeName || !this.signeeName.trim().length || this.signeeName.trim().length < 5) {
          this.uploadErrors.push('You must enter a valid name longer than 4 characters.')
        }
        if(this.signatureEmpty) {
          this.uploadErrors.push('You must sign your name in the box above.')
        }
      }
      if(this.uploadErrors.length) {
        this.loadingImageUpload = false;
        this.loadingUnsignedImageUpload = false;
        return;
      }
      // collapse page
      this.showTxtAdv = false;
      this.showTxtReb = false;
      this.showTxtProt = false;
      // fall back to testing PatNum on development & staging
      let uploadPatNum = this.pat_num;
      if(this.environment !== "production") {
        uploadPatNum = 27;
      }
      // console.log({uploadPatNum});
      // wait for next tick so DOM updates
        // hides showTxt sections
        // removed padding-botton form name input so it's not clipped in screenshot
      this.$nextTick(() => {
        // console.log('nextTick');
        // save screenshot of full page including signature
        html2canvas(document.body, {
          scale: 1, // override device pixel density
          windowWidth: 1000, // always make 1k wide image
          // windowHeight: 1000, // don't set so it remains auto
          scrollX: 0,
          scrollY: 0,
          allowTaint: true,
          // foreignObjectRendering: true, // do not use, breaks a lot of things, maybe useful for testing
          // onclone: (clonedDocument) => {
          //   // Copy all fonts from the main document to the cloned document
          //   document.fonts.forEach(font => {
          //     clonedDocument.fonts.add(font);
          //   });
          // },
        }).then(async (canvas) => {
          // console.log('canvas created');
          // test
            // document.body.appendChild(canvas);
          // toBlob's default content type is "image/png"
          let blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
          // console.log('created blob.type', blob.type);
          // create filename
          // include unix timestamp
          const timestamp = Math.floor(Date.now() / 1000);
          // inclue human readable format like 20250225
          // const datestamp = new Date().toISOString().slice(0, 10).replaceAll('-','');
          const datestamp = moment.tz("America/Chicago").format("YYYYMMDD");
          const uploadFileName = `/customers/${this.custom_claims.customerId}/locations/${this.custom_claims.authorized_location}/${subFolderName}/${datestamp}_${uploadPatNum}_${this.treatment_plan.TreatPlanNum}_${timestamp}.png`
          // save image to firebase storage
          // console.log({uploadFileName});
          // set content type to png, in case it's not automatically detected in some older browsers
          let uploadRef = Vue.storage.ref().child(uploadFileName);
          return uploadRef.put(blob, {contentType: 'image/png'});
        })
        .then(() => {
          console.log('upload success');
          this.loadingImageUpload = false;
          this.loadingUnsignedImageUpload = false;
          if(subFolderName == "signatures") {
            this.successImageUpload = true;
          }
          if(subFolderName == "unsigned") {
            this.successUnsignedImageUpload = true;
          }
        })
        .catch(err => {
          console.error(err);
          this.uploadErrors.push(err);
        });
      }); // nextTick
    },
    // vue-signature
    clearSignature() {
			this.$refs.signature.clear();
      // also update signatureEmpty boolean
      this.updateSignatureEmpty();
		},
    updateSignatureEmpty (event) {
      if(event) {
        // console.log('event',event.type);
      }
      this.signatureEmpty = this.$refs.signature.isEmpty();
      // console.log('signatureEmpty',this.signatureEmpty)
    },
    timeoutResize () {
      // use timeout function so that the siognature component's key is not reset at too high a rate
      // console.log('timeoutResize')
      if(this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }
      this.resizeTimeout = setTimeout(this.handleResize,300);
    },
    handleResize() {
      // console.log('handleResize')
      let oldWidth = this.signatureWidth;
      let width;
      // console.log('window.innerWidth',window.innerWidth)
      // Calculate new canvas size based on window size & Bootstrap brakpoints
        // xl -  1200px min-width ==> 1140px
        // lg - 992px min-width ==> 960px
        // md - 768px min-width ==> 720px
        // sm - 576px min-width ==> 540px
        // col-lg-9 is 75% of container
        // multiply by .75 for col-lg-9
        // subtract 30 for column padding
        // subtract 2 for signature box border
      if(window.innerWidth >= 1200) {
        width = (1140 * .75) - 30 - 2;
      }
      else if(window.innerWidth >= 992) {
        width = (960 * .75) - 30 - 2;
      }
      else if(window.innerWidth >= 768) {
        width = 720 - 30 - 2;
      }
      else if(window.innerWidth >= 576) {
        width = 540 - 30 - 2;
      }
      // fallback size for smallest screens
      else {
        width = 450;
      }
      // conditional so signature component is only recycled if the size actually changed
      if(String(width) !== oldWidth) {
        this.signatureWidth = String(width);
        this.signatureKey += 1;
        this.signatureEmpty = true;
      }
    },
  },
  async mounted () {
    if(this.treatment_plan && this.treatment_plan.TreatPlanNum) {
      this.loadLocation();
      this.loadPlanData();
      // this.loadPatGoal();
    }
    if(this.pat_num) {
      this.patNum = this.pat_num;
      this.loadPatGoal();
    }
    if(this.custom_claims && this.custom_claims.customerId && this.custom_claims.authorized_location) {
        this.loadPhoto(`/customers/${this.custom_claims.customerId}/locations/${this.custom_claims.authorized_location}/qr-financing-${this.custom_claims.authorized_location}.png`,'imgUrlQrFinancing');
        this.loadPhoto(`/customers/${this.custom_claims.customerId}/locations/${this.custom_claims.authorized_location}/qr-HA-${this.custom_claims.authorized_location}.png`,'imgUrlQrHA');
      }
  },
}
</script>

<style lang="less" scoped>
@import "../assets/less/variables.less";

.corner-actions-menu {
  position: absolute;
  top: 20px;
  right: 20px;

  .btn .fas {
    opacity: 0.1;
  }
  .btn:hover .fas {
    opacity: 1;
  }
  // position & override green check
  .fa-stack-1x.fa-check.color-green {
    opacity: 1 !important;
    text-align: right;
    left: 15px;
  }
}

.hilite-salmon {
  text-decoration: underline;
  background-color: @color-salmon;
}
.hilite-green {
  text-decoration: underline;
  background-color: @color-green;
}
.btn-scroll {
  background: @light-color;
  opacity: 0.5;

  &:hover {
    opacity: 1;
  }
}
.col-intro {
  height: 80vh; // 80% of viewport height or 100vh for 100%
  min-height: 600px;

  h3.title {
    margin-top: 70px;
    line-height: 1em;
  }
}
// treatment plan body
// ----------
.tp-title {
  margin: 100px 0;
  // temp to test scrollIntoView
  // padding-bottom: 1000px;

  h1,h3 {
    line-height: 1em;
    margin: 0;
  }
  p {
    line-height: 1em;
  }
  h1 {
    margin-bottom: 5px;
  }
  p.patient-goal {
    margin-bottom: 5px;
  }
  p.patient-goal:last-child {
    margin-bottom: 0;
  }
}
.btn-section {
  border: 1px solid @dark-color !important;
  margin: 0;
  padding: 20px;

  h2,h3,p,i {
    margin: 0 15px 0 0;
  }
  i {
    margin: 0;
  }
  p, i {
    line-height: 18px;
  }
  h2, h3 {
    line-height: 24px;
  }
}
.btn-section-adv {
  background-color: fadeout(@color-renken-green, 80%);
}
.btn-section-reb {
  background-color: fadeout(@color-renken-blue, 80%);
}
.btn-section-prot {
  background-color: fadeout(@color-magenta, 80%);
}
.row-section {

  .col {
    border-left: 1px solid @dark-color;
    border-right: 1px solid @dark-color;
    border-bottom: 1px solid @dark-color;
    padding: 20px 30px;
  }
  @media (min-width: @screen-md-min) {
    .col {
      border-right: none;
    }
    .col:last-child {
      border-right: 1px solid @dark-color;
    }
  }
  
  .col h2 {
    margin: 0;
  }
  .col hr {
    margin: 20px 0;
  }
}
.row-table {
  margin-top: 30px;
  margin-bottom: 50px;
}
.table.table-app {
  td, th {
    text-align: right;
  }
  tbody + tbody {
    border: none;
  }
  tfoot {
    font-weight: 700;
  }
  thead tr th {
    border: none; // reset
    border-bottom: 1px solid @dark-color;
  }
  tbody tr td {
    border: none; // reset
    border-bottom: 1px solid @dim-color;
  }
  tbody tr:last-child td {
    border-color: @dark-color;
  }
  tfoot tr td {
    border: none; // reset
    border-top: 1px solid @dark-color;
  }
  tr.subtot-internal {
    border-top: 2px solid @dim-color;
  }
}

// stretch table columns
.table-category tbody tr:not(.subtot-internal) td:nth-child(2),
.table-category tfoot tr.subtot td:nth-child(2),
.table-category thead tr th:nth-child(2),
.table-summary tr td:first-child,
.table-summary tr th:first-child {
  width: 72.5%;
  text-align: left;
}
.table-category tr td:first-child,
.table-category tr th:first-child {
  text-align: left;
}

.col-summary-title {
  margin-top: 20px;

  h2 {
    margin: 0 0 20px;
  }
  hr {
    margin: 0 0 20px;
  }
  p.patient-goal {
    margin-bottom: 5px;
  }
  p.patient-goal:last-child {
    margin-bottom: 0;
  }
}
// promo boxes
.proc-promo {
  padding: 40px;
  position: relative;
  border: 3px solid transparent;
  transition: all 250ms ease-in-out;
  cursor: pointer;

  h1, p {
    margin: 0;
    color: @dark-color !important;
  }
  > p {
    padding-left: 40px;
  }
  > div {
    min-width: 30%;

    p {
      line-height: 1em;;
    }
  }
  .proc-promo-float {
    position: absolute;
    top: 0;
    left: 0;
    font-size: 12px;
    line-height: 12px;
    padding: 5px 5px 7px;
    border-radius: 3px;
    background-color: @light-color;
    color: @dark-color !important;
    // border-right: 1px solid @light-color;
    // border-bottom: 1px solid @light-color;
    // border: 1px solid @color-green;
  }
  &:hover {
    border: 3px solid @dark-color;
  }
}
.proc-promo.proc-promo-adv {
  background-color: fadeout(@color-renken-green, 80%);
}
.proc-promo.proc-promo-reb {
  background-color: fadeout(@color-renken-blue, 80%);
}
.proc-promo.proc-promo-prot {
  background-color: fadeout(@color-magenta, 80%);
}
// cost boxes
.cost-box {
  padding: 40px;
  min-height: 100%;
  margin-bottom: 30px;
}
.cost-box.cost-box-financing {
  background-color: @dark-color;

  h1,h3,p {
    color: @light-color;
  }
}
.cost-box.cost-box-ha {
  background-color: fadeout(@color-blue, 50%);
}
// vue-signature
.col-sign {
  position: relative;
  padding: 100px 15px;
  margin-top: 50px;

  h1, h3, p, label, ul.list-errors, li, small, i {
    color: @light-color;
  }
  &:before {
    content: '';
    display: block;
    background-color: @dark-color;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;

    @media (min-width: @screen-xs-min) {
      width: 200%;
      left: -50%;
    }
  }
}
.signature-container {
  margin-bottom: 10px;
}
.signature-instructions {
  margin-bottom: 30px;
}
// btn overrides on dark bg
.btn-lg:hover {
  color: @dark-color;
  background-color: @light-color;
}
.col-sign {
  background-color: @dark-color;
  
  .btn-link {
    color: @light-color;
  }
  .btn-link:hover {
    color: @color-blue;
  }
}
.img-svg {
  background-color: #fff;
  border-radius: 500px;
}
.img-bg {
  display: block;
  width: 150px;
  height: 150px;
}
// HA discounts
.proc-promo-ha {
  background-color: fadeout(@color-blue, 50%);
  padding: 90px;
  margin-top: 50px;
  margin-bottom: 50px;

  h3 {
    margin: 0 0 20px;
  }
  h1 {
    margin: 0 0 40px;
    font-size: 40px;
  }
  h3:last-child {
    margin: 0;
  }
  > div {
    min-width: 100%;
  }
}
hr.ha-table-footer {
  border-top-color: @light-color;
}


// plans table
// copied from ha-app SalesView.vue
// -----

// ha color vars
@ha-dark-color:  #11788a;
@ha-major-color: #00b6d7;
@ha-light-color: #fff;
@ha-box-color:   #f3fcfc;
@ha-text-color:  #333;

.swipe-indicator {
  display: none;
}
.plans-table {
  margin: 50px 0;
}
@media (max-width: @screen-md-min) {
  .plans-table-inner {
    min-width: 800px;
  }
  .plans-table {
    overflow-x: auto;
    // padding-top: 100px;
  }
  .swipe-indicator {
    display: block;
    // margin-top: 50px;
    // position: relative;
    // z-index: 100;
    // margin-bottom: -125px;
    // pointer-events: none;
  }
}

.row-plans-header {
  .col {
    background-color: @ha-dark-color;
    padding: 30px;
    text-align: center;

    h4 {
      margin: 0;
      line-height: 1em;
      color: @ha-light-color;
    }
  }
  .col:first-child {
    background-color: @ha-box-color;

    h4 {
      color: @ha-dark-color;
    }
  }
  .col:last-child {
    background-color: @ha-major-color;

    h4 {
      color: @ha-light-color;
    }
  }
}
.row-dk .col {
  background-color: #222;
  padding: 15px;
  text-align: center;

  p {
    color: @ha-light-color;
    margin: 0;
  }
}
.row-plans-benefits {
  .col {
    background-color: fadeout(@ha-dark-color, 90%);
    padding: 20px 30px;
  }
  .col:first-child {
    background-color: @ha-box-color;
  }
  .col:last-child {
    background-color: fadeout(@ha-major-color, 80%);
  }
}
.benefits {
  /deep/ p {
    margin: 20px 0;
  }
  /deep/ p:first-child {
    margin-top: 0;
  }
  /deep/ ul {
    margin: 0;

    > li:before {
      color: @ha-text-color;
      // display: block;
      // float: left;
    }
    > li:last-child {
      margin: 0 !important;
    }
    > li > p {
      margin: 0;
      // display: inline-block;
      display: inline;
    }
  }
}
.plan-price {
  margin: 0;
}
.plan-price:last-child:not(:first-child):before {
  content: 'or';
  display: block;
  font-style: italic;
}
.ha-highlight {
  background-color: @ha-box-color;
  border-bottom-color: @ha-dark-color !important;
}
.col-close-table {
  padding-top: 10px;
  padding-bottom: 10px;
}
// Print Styles
// --------------------
@media print {
  @page {
    size: letter;
  }
  table,
  div {
    break-inside: auto;
  }
  .col-intro {
    height: auto;
    min-height: auto;

    h3.title {
      margin-top: 20px;
      line-height: 1em;
    }
  }
  .btn-close-plan,
  .btn-scroll,
  .image-gallery /deep/ .banner-upload {
    display: none !important;
  }
  .tp-title {
    margin: 50px 0;
  }
  .row-table {
    margin-top: 10px;
    margin-bottom: 30px;
  }
  .row-cost-saving {
    margin-bottom: 30px;

    .col-lg-6 {
      flex: 0 0 50% !important;
      max-width: 50% !important;
    }
  }
  .cost-box.cost-box-financing {
    background-color: @light-color;
    border: 5px solid @dark-color;

    h1,h3,p {
      color: @dark-color;
    }
  }
  .col-sign {
    background-color: @light-color;
    border-top: 5px solid @dark-color;
    
    &:before {
      background-color: transparent;
    }
    h1, h3, p, label, ul.list-errors, li, small, i {
      color: @dark-color;
    }
    .signature-container {
      border: 2px solid @dark-color;
    }
  }
  .proc-promo-ha {
    display: none !important;
  }
  // ha
  .row-dk .col {
    background-color: @light-color;
    border: 2px solid @ha-dark-color;

    p {
      color: @dark-color;
      font-weight: 700;
    }
  }
  .row-plans-header {
    .col {
      background-color: @light-color;
      border: 2px solid @ha-dark-color;

      h4 {
        color: @dark-color;
        font-weight: 700;
      }
    }
    .col:first-child {
      background-color: @light-color;

      h4 {
        color: @dark-color;
      }
    }
    .col:last-child {
      background-color: @light-color;

      h4 {
        color: @dark-color;
      }
    }
  }
}
</style>
